<script>
import DateTime from '../../../functions/lib/dateTime.js';
import { getAllClubViews, getClubCalendarViews } from '../../js/readModel.js';
import { generateCalendarForMonth } from '../../js/utils/calendar-grid.js';
import { showConfirm} from '../../js/utils/confirm.js'

export const pageName = 'clubs';
export const pageRoute = '/clubs';
export const title = 'Clubs'
export const requireMembership = true;

export default {
	data() {
		return { 
			clubs: [],
			nextEvent: null,
			currentMonthCalendar: [],
			today: DateTime.today,
			ready: false
		}
	},

	methods: {
		async boot(opts) {

			// TODO: listen
			let clubs = await getAllClubViews();
			let calendarIds = clubs.map(c => ({
				clubId: c.id,
				calendarId: c.calendars[DateTime.today.year]
			})).filter(x => x.calendarId);

			// TODO: listen
			let calendars = await getClubCalendarViews(calendarIds);

			this.clubs = clubs.map(club => {
				let newClub = {
					id: club.id,
					name: club.name,
					logoUrl: club.logoUrl,
					url: club.url,
					coords: club.coords,
					events: [],
					ukraAffiliated: club.ukraAffiliated
				}
				
				newClub.calendar = calendars.find(cal => cal.id == club.calendars[DateTime.today.year]);
				if(newClub.calendar)
				{
					newClub.events = newClub.calendar.allEvents
					newClub.events.forEach(e => e.club = newClub);
				}

				return newClub;
			})

			let allEvents = this.clubs.flatMap(c => c.events)

			this.currentMonthCalendar = generateCalendarForMonth(DateTime.today.year, DateTime.today.month, allEvents)

			this.ready = true;
		},
		showEvents(day)
		{
			if(!day.events.length)
				return;
			
			showConfirm({
				title: day.date.format('dd MMMM yyyy'),
				message: day.events.map(e => `${e.club.name}: ${e.name}`).join(''),
				buttons: [
					{
						text: 'Close',
						style: 'primary'
					}
				]
			})
		},
	}
}

</script>
<template>
	<div v-show="ready" class="container py-5" ref="page">
		<div class="row justify-content-center">
			<div class="col-12 col-md-8 col-xl-6 my-5">
				<h1 class="display-4 text-center mb-3">UKRA Clubs</h1>
				<p class="text-muted text-center mb-5">Explore the UK's rocket clubs.</p>
				
				<div v-if="nextEvent" class="card">
					<div class="card-header">
						<h4 class="card-header-title">Next event: {{ nextEvent.name }}</h4>
					</div>
					<div class="card-body">
						<p>{{ nextEvent.date }}</p>>
						<p v-if="event.status == 'planned'"><span class="fe fe-help-circle text-primary"></span> Planned to go ahead<span v-if="event.statusNotes">: {{ event.statusNotes }}</span></p>
						<p v-if="event.status == 'confirmed'"><span class="fe fe-check-circle text-success"></span> Confirmed<span v-if="event.statusNotes">: {{ event.statusNotes }}</span></p>
						
						<p v-if="event.type == 'regular'">Regular flying day</p>
						<p v-if="event.type == 'regular'">Special event</p>
						<p v-if="event.notes">{{ event.notes }}</p>
					</div>
				</div>

				<!-- <div class="card">
					<div class="card-header">
						<h4 class="card-header-title">{{ today.format('MMMM yyyy') }}</h4>
					</div>
					<table class="table card-table table-sm">
						<thead>
							<tr>
								<th>Mon</th>
								<th>Tue</th>
								<th>Wed</th>
								<th>Thu</th>
								<th>Fri</th>
								<th>Sat</th>
								<th>Sun</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="week in currentMonthCalendar">
								<td @click.prevent="showEvents(day)" v-for="day in week" :class="`text-center ${day.events?.length ? 'table-primary' : null}`">
									{{ day.date?.day }}
								</td>
							</tr>
						</tbody>
					</table>
				</div> -->

				<div class="card" v-for="club in clubs">
					<div class="card-header">
						<h4 class="card-header-title">{{ club.name }}</h4>
						<a v-if="club.ukraAffiliated" :href="`/clubs/${club.id}`" class="btn btn-sm btn-primary">More <span class="fe fe-arrow-right-circle"></span></a>
					</div>
					<div class="card-body">					
						<p v-if="!club.ukraAffiliated" class="small text-muted mb-0">This club is not UKRA affiliated; you need to engage with them directly for event information.</p>
						<div v-else>
							<div class="row">
								<div class="col-auto">
									<img :src="club.logoUrl" :alt="club.name" style="width:100px" />
								</div>
								<div class="col">
									<p><a :href="club.url" target="_blank">{{ club.url }} <span class="fe fe-external-link"></span></a></p>
									<p class="small mb-0">{{ club.notes }}</p>
									<div class="row">
										
										<div class="col">
											<div>Next event: {{ club.calendar?.futureEvents[0]?.date }}</div>
											<span v-if="club.calendar?.futureEvents[0]?.status == 'planned'" class="badge badge-light"><span class="fe fe-help-circle text-primary"></span> Planned</span>
											<span v-if="club.calendar?.futureEvents[0]?.status == 'confirmed'" class="badge badge-success"><span class="fe fe-check-circle "></span> Confirmed</span>
											<span v-if="club.calendar?.futureEvents[0]?.status == 'cancelled'" class="badge badge-danger"><span class="fe fe-x-circle"></span> Cancelled</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
